import React, { Fragment } from "react";
import { isDisplayable } from "util/misc";
import GameField from "games/GameField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: {
    display: "block",
    width: "100%",
    fontSize: "13px"
  }
});

const FootballFields = (props) => {
  const classes = useStyles();
  return (
    <Fragment>
      <GameField label="Total Points" inputName="totalPoints" {...props} />
      <h3 className={classes.title}>Passing</h3>
      <GameField
        label="Pass Completions"
        inputName="passingCompletions"
        {...props}
      />
      <GameField label="Pass Attempts" inputName="passingAttempts" {...props} />
      <GameField
        label="Pass Interceptions"
        inputName="passingInterceptions"
        {...props}
      />
      <GameField label="Passing Yards" inputName="passingYards" {...props} />
      <GameField
        label="Passing Touchdowns"
        inputName="passingTouchdowns"
        {...props}
      />
      <GameField
        label="Passing Average"
        inputName="passingAverage"
        disabled
        helperText="yards per pass attempt"
        {...props}
      />
      <GameField
        label="Passing Completion Percentage"
        inputName="passingCompletionPercentage"
        disabled
        transform={(val) => {
          if (!isDisplayable(val)) return;
          return `${val * 100}%`;
        }}
        {...props}
      />
      <h3 className={classes.title}>Rushing</h3>
      <GameField label="Rush Attempts" inputName="rushingAttempts" {...props} />
      <GameField label="Rushing Yards" inputName="rushingYards" {...props} />
      <GameField
        label="Rushing Touchdowns"
        inputName="rushingTouchdowns"
        {...props}
      />
      <GameField
        label="Rushing Average"
        inputName="rushingAverage"
        disabled
        helperText="yards per rush attempt"
        {...props}
      />
      <h3 className={classes.title}>Receiving</h3>
      <GameField label="Receptions" inputName="receptions" {...props} />
      <GameField
        label="Receiving Yards"
        inputName="receivingYards"
        {...props}
      />
      <GameField
        label="Receiving Touchdowns"
        inputName="receivingTouchdowns"
        {...props}
      />
      <GameField
        label="Receiving Average"
        inputName="receivingAverage"
        helperText="yards per reception"
        disabled
        {...props}
      />
      <h3 className={classes.title}>Field Goals</h3>
      <GameField
        label="Field Goal Yards"
        inputName="fieldGoalYards"
        {...props}
      />
      <GameField
        label="Field Goal Attempts"
        inputName="fieldGoalAttempts"
        {...props}
      />
      <GameField
        label="Field Goals Made"
        inputName="fieldGoalsMade"
        {...props}
      />
      <h3 className={classes.title}>Punts</h3>
      <GameField label="Punting Yards" inputName="puntingYards" {...props} />
    </Fragment>
  );
};

export default FootballFields;
